define('models/shared/qanda/questionandanswers',["backbone",
    "models/shared/qanda/question_collection"
], function (Backbone, Questions) {

    var QuestionandAnswers = Backbone.Model.extend({
       urlRoot: function () {
           return pf.consumerURL + "/OutOfWallet";
        },
        initialize: function (options) {

            options || (options = {});
            this.transactionID = options.TID;
            this.questionSetID = options.QSID;
            this.transactionResult = options.TR;
            this.detailCode = options.DC;
            this.transactionText = options.TT;
            this.lexID = options.LID;
            this.dateAttempted = options.DA;
            this.howManyRouts = options.HMR;
            this.CIPResultID = options.CIPRID;
            this.MyQuestions = new Questions(options.MQ, { parse: true });

        },
        parse: function (data) {

            var response = {};
            response.transactionID = data.TID;
            response.questionSetID = data.QSID;
            response.transactionResult = data.TR;
            response.detailCode = data.DC;
            response.transactionText = data.TT;
            response.lexID = data.LID;
            response.dateAttempted = data.DA;
            response.howManyRouts = data.HMR;
            response.CIPResultID = data.CIPRID;
            this.MyQuestions = new Questions(data.MQ, { parse: true });
           
            return response;
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};
            var data = {};
                      
            data.TID = this.transactionID;
            data.QSID = this.questionSetID;
            data.TR = this.transactionResult;
            data.DC = this.detailCode;
            data.TT = this.transactionText;
            data.LID = this.lexID;
            data.DA = this.dateAttempted;
            data.HMR = this.howManyRouts;
            data.MQ = this.MyQuestions;
            data.CIPRID = this.CIPResultID;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return QuestionandAnswers;
});

